import BasicDialog from "../../components/base/BasicDialog";

import { useEffect, useMemo, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Grid, Button, Typography } from "@mui/material";
import TextFieldFormControl from "../../components/field/TextFieldFormControl";

import { LoadingButton } from "@mui/lab";

import { useToasts } from "../../hooks/useToasts";
import toast from "react-hot-toast";

import { useProposalAcceptDialogTableFieldConfig, PROPOSAL_TABLE_NAME } from "./ProposalAcceptDialogFieldConfig";
import { useProposalById, useUpdateProposalMutation } from "../../services/productsService";

import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";

import FilterTable from "../../components/table/FilterTable";
import usePaginationWithSearchParams from "../../hooks/usePaginationWithSearchParams";
import TableService from "../../services/tableService";

export function ProposalAcceptDialog(props) {
    const { t } = useTranslation();

    const [dataLocal, setDataLocal] = useState();
    const [proposalAcceptNote, setProposalAcceptNote] = useState();

    const { data: proposalData, isLoading } = useProposalById(props.proposalId);
    const PROPOSAL_TABLE_FIELDS_CONFIG = useProposalAcceptDialogTableFieldConfig(props.proposalType)

    useEffect(() => {
        if (proposalData && !dataLocal) {
            setDataLocal([proposalData]);
        }
    }, [proposalData]);

    const data = useMemo(
        () =>
            TableService.getPreparedDataForCollapsibleTable(
                PROPOSAL_TABLE_FIELDS_CONFIG,
                dataLocal, // @ts-ignore
                [], // @ts-ignore
                [],
            ),
        [
            PROPOSAL_TABLE_FIELDS_CONFIG,
            dataLocal,
        ],
    );

    const { onServerError } = useToasts();

    const { mutate: updateProposal, isPending: isAddingProposal } = useUpdateProposalMutation({
        onSuccess: () => {
            toast.custom(
                () => <SnackbarSuccess message={t("successfullyEdited")} />,
                {
                    position: "bottom-right",
                },
            );
            props.onClose()
        },
        onError: (error) => {
            onServerError(error);
        },
    });    

    const onSubmit = (decission) => {
        updateProposal({id: props.proposalId, data:{proposal_accepted: decission, proposal_accept_note: proposalAcceptNote}})
    };


    return (
        <BasicDialog
            open={true}
            onClose={() => props.onClose()}
            titleAlign={"center"}
            contentAlign={"center"}
            title={props.proposalType === 'discount' ? t("products.acceptProposalDiscount") : t("products.acceptProposalStatus")}
            maxWidth={"xxl"}
            showDialogActions
            alwaysFullScreen={false}
            contentSx={{ pt: 0 }}
        >
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                rowSpacing={1}
                columnSpacing={2}
            >
                <Grid item xs={12}>
                    <FilterTable
                        // @ts-ignore
                        data={data}
                        countRecords={1}
                        style={{ maxHeight: "60vh" }}
                        headersConfig={PROPOSAL_TABLE_FIELDS_CONFIG}
                        showCleanFilterIcon={false}
                        showContextMenu={false}
                        showExportToFileButton={false}
                        showFilters={false}
                        showDetailsIcon={false}
                        showCheckbox={false}
                        withPagination={false}
                        showPagination={false}
                        showCounterRecords={false}
                        isLoading={isLoading}
                    />
                </Grid>
                <Grid item xs={12} marginTop={1}>
                    <TextFieldFormControl
                        label={t("products.columns.proposal_accept_note")}
                        value={proposalAcceptNote}
                        onChange={(e)=>setProposalAcceptNote(e.target.value)}
                        multiline
                        rows={3}
                    />
                </Grid>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={3}
                    marginTop={1}
                >
                    <Grid item xs={6} textAlign={"right"}>
                        <LoadingButton
                            style={{ minWidth: "200px" }}
                            variant="contained"
                            size="small"
                            onClick={()=>onSubmit(true)}
                            color={"success"}
                            loading={isLoading}
                        >
                            {t("true")}
                        </LoadingButton>
                    </Grid>
                    <Grid item xs={6} textAlign={"left"}>
                        <Button
                            color={"error"}
                            style={{ minWidth: "200px" }}
                            variant="contained"
                            size="small"
                            onClick={()=>onSubmit(false)}
                            disabled={isLoading}
                        >
                            {t("false")}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </BasicDialog>
    );
}